// prefill contact form 
(function () {
  console.log('test');
  var urlString = window.location.href;
  var url = new URL(urlString);
  var p = url.searchParams.get('p');
  if(p){
    var isEnglish = urlString.includes('/en/');
    var target = document.getElementById('contact-ContactForm-block-3');
    if(target){
      content = "Ich interessiere mich für Prototyp " + p + " oder würde ihn gerne als Inspiration für weitere Ideen benutzen. Für das weitere Vorgehen möchte ich gerne kontaktiert werden."
      if(isEnglish){
        content = "I am interested in prototype " + p + " or would like to use it as inspiration for further ideas. I would like to be contacted about the next steps."
      }
      target.value = content;
    }
  }
})();
// end prefill contact form 